import { Auth } from 'aws-amplify';

const signOut = async () => {
  await Auth.signOut({ global: true });
};

export const cognitoUtils = {
  signOut,
};
